export interface VersionInfo {
	version: string;
	buildNumber: string;
	environment: Environment;
}

export enum Environment {
	LOCAL_DEV = "LOCAL_DEV",
	DEVELOP = "DEVELOP",
	TEST = "TEST",
	PRODUCTION = "PRODUCTION"
}
